module.exports = __webpack_public_path__ + "img/uneovc.b8ce67eb.jpg";